<mat-card>
    <mat-card-title *ngIf="title">{{title}}</mat-card-title>
    <mat-card-content>

        <vedrax-form [descriptor]="descriptor" (onSubmit)="submit($event)" (onCancel)="cancel($event)">
        </vedrax-form>

    </mat-card-content>
</mat-card>